import http from '../../api';

export default async function ({ importDataId, ...data }) {
  try {
    const response = await http.post(`import-service/${importDataId}`, data);
    return response;
  } catch (e) {
    console.error(e);
  }
}
